export const dataLocal: any = {
    jp: {
        data1: [
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1724506824844/tab1_bundles_1.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1724507362796/tab1_bundles_1_h5.jpg',
                    },
                ],
                info: {
                    desc: '230Wh ｜300W 出力 ｜450W X-Boost\n業界平均よりも30%軽量化\n100W以下の家電の稼働時間を最大81%延長\n30dB未満の静音設計\n20ミリ秒未満のUPS機能',
                    // discountPrice: 30900,
                    // originalPrice: 30900,
                    // pointRate: 5,
                    productId: '8097380106401',
                    variantId: '51662131593583',
                    showBtnMore: false,
                    buyUrl: 'https://jp.ecoflow.com/products/river-3-portable-power-station?variant=51662131593583',
                    link_buy: '購入手続きへ',
                    link_cart: 'カートに追加',
                },
            },
        ],
        data2: [
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1724506914268/tab2_bundles_1.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1724507419321/tab2_bundles_1_h5.jpg',
                    },
                ],
                info: {
                    desc: '230Wh ｜300W 出力 ｜450W X-Boost\nいつでもどこでも充電できるポータブルセット\n業界トップレベルの変換効率\nアウトドアや日常での節約に最適',
                    // discountPrice: 152810,
                    // originalPrice: 218300,
                    // pointRate: 5,
                    productId: '8097380696225',
                    variantId: '44505652854945',
                    showBtnMore: false,
                    link_buy: '購入手続きへ',
                    link_cart: 'カートに追加',
                },
                direction: 'rtl',
            },
        ],
        data3: [
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    name: 'RIVER 3 (230) + 45Wソーラーパネル (Type-C)',
                    // discountPrice: 213395,
                    // originalPrice: 328300,
                    // pointRate: 5,
                    productId: '8102406029473',
                    variantId: '44522544267425',
                    showBtnMore: false,
                    link_buy: '購入手続きへ',
                    link_cart: 'カートに追加',
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    name: 'RIVER 3 (230) + 60Wソーラーパネルセット',
                    // discountPrice: 213395,
                    // originalPrice: 328300,
                    // pointRate: 5,
                    productId: '8102403113121',
                    variantId: '44522530865313',
                    showBtnMore: false,
                    buyUrl: 'https://jp.ecoflow.com/products/river-3-60w-solar-panel-bundle',
                    link_cart: 'カートに追加',
                },
            },
        ],
    },
    us: {},
    ca: {},
    eu: {},
    de: {},
    fr: {},
    it: {},
    es: {},
};
